import { ReactNode } from 'react';

type Props = {
  text: string;
  caption: ReactNode;
  isFetching?: boolean;
};

export const StatCard = ({ text, caption, isFetching }: Props) => {
  return (
    <div className="relative inline-flex flex-col items-center justify-center min-w-full lg:min-w-0 bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 p-8 text-xs lg:text-base">
      <p className="mb-2 text-xl lg:text-3xl font-extrabold">{text}</p>
      <p className="text-gray-500 dark:text-gray-400">{caption}</p>
      {isFetching ? (
        <div className="absolute top-0 bottom-0 left-0 right-0 flex items-center justify-center backdrop-blur-sm" />
      ) : null}
    </div>
  );
};
